module.exports = __webpack_public_path__ + "img/barrier.6f01dbd0.svg";